/* Copyright 2013 The MathWorks, Inc. */

/* Mixin for slider properties
 This mixin will help in setting the properties
 */

define([
    "dojo/_base/declare"
], function (declare) {
    return declare(null, {

        _setStepsAttr: function (value) {
            this._set("steps", value);
        },
        //Setting number of ticks will compute the position of the minor Ticks
        // Pass the computed array to minorTicks setter of Appdesigner
        _setNumberOfTicksAttr: function (value) {
            this._set("numberOfTicks", value);
            var tickValue = this.minimum, computedMinorTicks = [];
            if (value > 1) {
                while (computedMinorTicks.length < value - 1) {
                    computedMinorTicks.push(tickValue);
                    tickValue = tickValue + ((this.maximum - this.minimum) / (this.numberOfTicks - 1));
                }
                computedMinorTicks.push(this.maximum);
                this.set("minorTicks", computedMinorTicks);
                //If number of Ticks is less than 2, then pass empty array to minor Ticks
            } else if (value === 1) {
                computedMinorTicks.push((this.maximum + this.minimum)/2);      //TODO: no need of push
                this.set("minorTicks", computedMinorTicks);
            } else {
                this.set("minorTicks", []);
            }            
        },
        // Pass Labels and store them in MajorTickLabels
        // Compute MajorTicks
        _setLabelsAttr: function (value) {
            var labelValue = this.minimum, computedMajorTicks = [];
            this._set("labels", value);
            if (value.length > 0) {
                if (value.length === 1) {
                    computedMajorTicks.push((this.minimum + this.maximum)/2);     //no need of push
                } else {

                    while (labelValue <= this.maximum) {
                        computedMajorTicks.push(labelValue);
                        labelValue = labelValue + ((this.maximum - this.minimum) / (this.labels.length - 1));
                    }
                }
                this.set("majorTicks", computedMajorTicks);
                this.set("majorTickLabels", value);
                // If labels is empty array
            } else {
                this.set("majorTicks", []);
                this.set("majorTickLabels", []);
            }
        }
    });
});
